import http from '@/services/http.js';

export const login = async (username, encryptedPassword) => {
  const response = await http.post(`/videoapi/user/login`, {
    username,
    password: encryptedPassword,
  });
  return response;
};
